import React from 'react';
import Spinner from '@atlaskit/spinner';

import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { Appearance } from '@atlaskit/spinner';
import './botao.scss'

export type BotaoTipo = ''|'default'|'cancel'|'warning'|'success'

export interface BotaoProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  /**
   * Tipo de botão. Corresponde a aparência do botão
   */
  tipo?: BotaoTipo
  isLoading?: boolean
  textoOnLoading?: string
  aparenciaLoading?: Appearance
}

export const Botao = React.forwardRef<any, BotaoProps>(({className, tipo, isLoading, textoOnLoading, aparenciaLoading, ...props}, ref) => {
  const conteudo = [];

  if (textoOnLoading && isLoading) {
    conteudo.push(textoOnLoading);
  } else {
    conteudo.push(props.children);
  }

  if (isLoading === true) {
    conteudo.push(<SpinnerContainer><Spinner appearance={aparenciaLoading ?? "invert"} size="small" /></SpinnerContainer>);
  }

  return <button 
      ref={ref}
      disabled={isLoading}
      {...props}
      className={`button ${tipo || 'default'} ${className}`}
    >{conteudo}</button>
});

export const BotaoFlat = React.forwardRef<any, BotaoProps>((props, ref) => {
  return <Botao
    ref={ref}
    {...props as any}
    className={`flat ${props.className}`}
    aparenciaLoading="inherit"
  />
})

export const BotaoClean = React.forwardRef<any, BotaoProps>((props, ref) => {
  return <Botao
    ref={ref}
    {...props as any}
    className={`clean ${props.className}`}
    aparenciaLoading="inherit"
    />
})


export const SpinnerContainer = styled.span`
  margin-left: ${Spacing.unit/2}px;
`;
